import React from 'react';
import { connect } from 'react-redux';
import { TableCell } from 'semantic-ui-react';

import { AppState } from 'services/types';
import {
    CalibrationId,
    CalibrationRowSpacingMin
} from 'services/equipmentSets/types';
import { createStructuredSelector } from 'reselect';
import { WorksheetPageIndex } from 'services/worksheet/types';
import { makeSelectMinRowWidth } from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    calibrationId: CalibrationId;
}

interface ConnectedProps {
    minRowWidth: CalibrationRowSpacingMin;
}

type Props = OwnProps & ConnectedProps;

export class MinRowWidthTableCellComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { minRowWidth } = this.props;

        return <TableCell>{minRowWidth}m</TableCell>;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    minRowWidth: makeSelectMinRowWidth()
});

export default connect(mapStateToProps)(MinRowWidthTableCellComponent);
